import React from "react";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import AmoModal from "components/AmoModal";

/**
 * @param {object} props - object containing props for this component
 * @param {boolean} props.showModal - controls visibility of the modal
 * @param {number} props.year - year for the title
 * @param {Function} props.closeModal - function triggered when closing the modal
 * @returns - the Help Reconciliation modal, styled for the AMO project
 */
const ReconciliationHelpModal = (props) => {
  const { showModal, year, closeModal } = props;

  return (
    <AmoModal
      data-testid="reconciliationHelpModal"
      open={showModal}
      variant="default"
      title="The Reconciliation Page"
      width="50rem"
      showButton
      closePopover={() => closeModal()}
      buttonsLeftSpacer={5}
      buttons={[
        {
          key: "close",
          label: "Close",
          color: "primary",
          variant: "outlined",
          width: "9rem",
          onClick: () => {
            closeModal();
          },
        },
      ]}
    >
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        This page tracks changes made to financial information after our annual
        audit.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        Review this page regularly to confirm that amounts reconcile with our
        audited statements. Variances should be nil.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        Changes are logged as they are made. Any variances that emerge therefore
        indicate an error in the site. Contact IT if this occurs.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        You can view changes made since the audit by selecting “Changes” from
        the drop-down menu to the top left. Select a change to edit it.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        Both current and cumulative amounts are reconciled on this page. Use the
        drop-down menu to toggle between the two. Note that cumulative amounts
        date back to the year in which the current agreement began.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">{`Ready to start the audit? Click “Close ${year}” to populate the audit table. All changes made after this point will need to be logged.`}</Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">{`Need to update the audit? Click “Update ${
        year - 1
      }” to replace amounts in the audit table with current values. Note that all changes made up to this point will be wiped from the database; all changes made after this point will need to be logged.`}</Typography>
      <Grid item>&nbsp;</Grid>
    </AmoModal>
  );
};

ReconciliationHelpModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  year: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ReconciliationHelpModal;
